import widgetsDataService from "../../services/widgetsDataService";

const coinShortInfo = {
    async updateDynamicsData() {
        let data = $('.short-info-widget').data();
        let widgetData = await widgetsDataService.fetchWidgetDataAsync('getCoinShortInfoData', data.coinId, data.currency);

        widgetsDataService.updateDataOnPage('.short-info-widget', widgetData);
    }
}

export default coinShortInfo;